module.exports = __webpack_public_path__ + "static/media/icon-app.2ea94fa6.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icon-app.svg
// module id = ./src/assets/images/icon-app.svg
// module chunks = 6